import React, { useContext } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import { ClientPortalContext } from '../ClientPortal'
import { UserContext } from '../../../../App'
import Event from '../pages/Event/Event'
import { useRoutes } from 'react-router-dom'
import Dashboard from '../pages/Dashboard/Dashboard'
import NotFound from '../../../../components/NotFound'
import Events from '../pages/Events/Events'
import ComingSoon from '../../../../components/ComingSoon'
import Incidents from '../pages/HealthSafetyIncidents/Incidents'
import SingleIncident from '../pages/HealthSafetyIncidents/SingleIncident'

const ClientPortalRoutes = () =>
  useRoutes([
    { path: '*', element: <NotFound /> },
    { path: '/', element: <Dashboard /> },
    { path: '/events', element: <Events /> },
    { path: '/events/:eventID', element: <Event /> },
    { path: '/health-safety-incidents', element: <Incidents /> },
    { path: '/health-safety-incidents/:id', element: <SingleIncident /> },
    { path: '/invoices', element: 'Invoices' },
    {
      path: '/request-cover',
      element: (
        <Box width="100%" display="flex" justifyContent="center">
          <ComingSoon noPaper />
        </Box>
      ),
    },
  ])

const ContentArea = () => {
  return (
    <Grid item xs={12}>
      <Box
        component={Paper}
        display="flex"
        borderRadius={2}
        padding={{ xs: 1, lg: 3 }}
      >
        <ClientPortalRoutes />
      </Box>
    </Grid>
  )
}

export default ContentArea
